import type { ReactNode } from 'react';
import { charCount } from './Field.css';

export function CharCount({ children }: { children: ReactNode }) {
  return <div className={charCount}>{children}</div>;
}
